
import { Watch, Prop } from 'vue-property-decorator';
import * as OM from '@/model';
import { Options, Vue } from 'vue-class-component';
import store from '@/store';

@Options({})
export default class offerResume extends Vue {

    @Prop() offer: OM.ShopOffer;
    @Prop({
        default: true
    }) descriptionToggler: boolean;

    showDescription: boolean = false;

}

